// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3JeUR","dragIcon":"Choice_dragIcon__1qacc","left":"Choice_left__2r9e7","input":"Choice_input__36nsl"};